import { createModalController } from '../shared/modal-controller';

createModalController({
    popupSelector: '.SizementTable',
    modalInnerSelector: '.SizementTable__box',
    openTriggerSelector: '#sizement-table-button',
    closeTriggerSelector: '#close-sizement-table',
    initialFocusSelector: '#close-sizement-table',
    lockScroll: true,
});
